// src/components/Navbar/DropdownMenu.js
import React from "react";

export default function DropdownMenu({
  label,
  isOpen,
  handleMouseEnter,
  handleMouseLeave,
  children,
}) {
  return (
    <div
      className="dropdown"
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <div className="dropdown-toggle">{label}</div>
      {isOpen && <div className="dropdown-menu">{children}</div>}
    </div>
  );
}
